import React from "react";
import LogoMain from "../images/main-logo.png"; 
import { FaApple, FaGooglePlay, FaInstagram, FaFacebook, FaLinkedin, FaGlobe, FaEnvelope, FaHeart } from "react-icons/fa";


function LinkButton({ href, icon, children, variant = "black" }) {
  const base =
    "group inline-flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium transition";
  const styles =
    variant === "black"
      ? "bg-gradient-to-r from-[#E35EA7] to-[#FF9BC5] text-white shadow-lg hover:opacity-90 shadow-[0_4px_4px_rgba(0,0,0,0.20),_inset_0_0_10px_rgba(0,0,0,0.08)]"
      : "bg-white text-neutral-900 ring-1 ring-black/10 hover:bg-white/95 shadow-[0_4px_4px_rgba(0,0,0,0.20),_inset_0_0_10px_rgba(0,0,0,0.08)]";

  return (
    <a href={href} target="_blank" rel="noreferrer" className={`${base} ${styles}`}>
      <span className="opacity-90">{icon}</span>
      <span>{children}</span>
    </a>
  );
}
const Icons = {
  mail: <FaEnvelope size={18} />,
  heart: <FaHeart size={18}/>,
  appstore: <FaApple size={18} />,
  playstore: <FaGooglePlay size={18} />,
  instagram: <FaInstagram size={18} />,
  globe: <FaGlobe size={18} />,
  facebook: <FaFacebook size={18} />,
  linkedin: <FaLinkedin size={18} />,
};

export default function TousNosLiens() {
  return (
    <div className="min-h-screen bg-white text-black">
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-[#FFEAF5]/30 to-white" />
        <div className="absolute -left-20 bottom-10 h-64 w-64 rounded-full bg-pink-200/40 blur-3xl" />
        <div className="absolute -right-16 top-20 h-56 w-56 rounded-full bg-fuchsia-200/40 blur-3xl" />
      </div>

      <main className="mx-auto max-w-[980px] px-4 py-10 sm:py-14">
        <div className="mx-auto max-w-[860px] overflow-hidden rounded-[28px] sm:rounded-[32px] bg-white/80 backdrop-blur ring-1 ring-black/10 shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
            <div className="p-6 sm:p-8 md:p-10">
              <div className="flex items-center gap-3">
                <img src={LogoMain} alt="PACTE" className="h-10 w-auto" />
              </div>

              <p className="mt-3 text-sm text-neutral-700 leading-relaxed">
                <span className="font-semibold">PACTE </span> — Promouvons nos Acteurs Claixois Tous Ensemble.
              </p>

              <div className="mt-6 space-y-3">
                <LinkButton href="mailto:contact@pacte-claix.fr" icon={Icons.mail}>
                  Nous écrire
                </LinkButton>
                <LinkButton href="https://pacte-claix.fr" icon={Icons.globe} variant="white">
                  Notre site
                </LinkButton>
              </div>

              <div className="my-6 h-px w-24 bg-neutral-300/70" />

              <div className="text-neutral-900 font-semibold">Nous soutenir</div>
              <div className="mt-3">
                <LinkButton
                  href="https://www.helloasso.com/associations/promouvons-nos-acteurs-claixois-tous-ensemble/formulaires/1"
                  icon={Icons.heart}
                  variant="white"
                >
                  Faire un don
                </LinkButton>
              </div>
            </div>

            <div className="p-6 sm:p-8 md:p-10 bg-gradient-to-b from-[#FFEAF5]/60 to-transparent md:border-l md:border-black/10">
              <div>
                <div className="text-neutral-900 font-semibold">Application mobile</div>
                <div className="mt-3 space-y-3">
                  <LinkButton
                    href="https://apps.apple.com/app/id6746101122"
                    icon={Icons.appstore}
                    variant="black"
                  >
                    App Store
                  </LinkButton>
                  <LinkButton
                    href="https://play.google.com/store/apps/details?id=com.claix.pacteclaixapp&pcampaignid=web_share"
                    icon={Icons.playstore}
                    variant="white"
                  >
                    Play Store
                  </LinkButton>
                </div>
              </div>

              <div className="my-6 h-px w-24 bg-neutral-300/70" />

              <div>
                <div className="text-neutral-900 font-semibold">Réseaux sociaux</div>
                <div className="mt-3 space-y-3">
                  <LinkButton href="https://www.instagram.com/pacte_claix_38" icon={Icons.instagram} variant="white">
                    Instagram
                  </LinkButton>
                  <LinkButton href="https://www.facebook.com/people/PACTE/61564146676538/" icon={Icons.facebook} variant="white">
                    Facebook
                  </LinkButton>
                  <LinkButton href="https://www.linkedin.com/company/pacte-claix/" icon={Icons.linkedin} variant="white">
                    LinkedIn
                  </LinkButton>
                </div>
              </div>
            </div>
          </div>

          <div className="px-6 sm:px-8 py-4 text-center text-xs text-neutral-500 bg-white/70">
            ©2025 PACTE — Tous droits réservés · <a href="https://noxzi.fr" className="">Propulsé par <span className="underline font-bold">NoxZi</span></a>
          </div>
        </div>
      </main>
    </div>
  );
}